import localeFr from '@angular/common/locales/fr';
import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import { InjectionToken, provideZoneChangeDetection } from '@angular/core';

import { appConfig } from './app.config';
import { MpsAppComponent } from './mps/components/mps-app/mps-app.component';

registerLocaleData(localeFr);

export const OAUTH2_PROVIDERS_URL = new InjectionToken<string>('OAUTH2_PROVIDERS_URL');
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
export const LOADER_ON_HTTP = new InjectionToken<string>('LOADER_ON_HTTP');

bootstrapApplication(MpsAppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]}).catch((err) => console.error(err));
